import React from 'react';
import Icon from '../../../components/AppIcon';

const PolicyUpdates = () => {
  const updates = [
    {
      id: 1,
      title: 'Privacy Policy Updated',
      description: 'Enhanced data retention policies and user rights clarification',
      date: '2026-01-20',
      type: 'update',
      icon: 'Shield'
    },
    {
      id: 2,
      title: 'New GDPR Compliance Features',
      description: 'Added data portability and right to be forgotten functionality',
      date: '2026-01-18',
      type: 'feature',
      icon: 'Sparkles'
    },
    {
      id: 3,
      title: 'Terms of Service Amendment',
      description: 'Updated membership cancellation and refund policies',
      date: '2026-01-15',
      type: 'update',
      icon: 'FileText'
    }
  ];

  const getTypeColor = (type) => {
    switch (type) {
      case 'update':
        return 'var(--color-primary)';
      case 'feature':
        return 'var(--color-success)';
      default:
        return 'var(--color-muted-foreground)';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Recent Updates</h3>
      <div className="space-y-4">
        {updates?.map(update => (
          <div key={update?.id} className="flex items-start gap-3 pb-4 border-b border-border last:border-b-0 last:pb-0">
            <div
              className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
              style={{ backgroundColor: `${getTypeColor(update?.type)}20` }}
            >
              <Icon name={update?.icon} size={20} style={{ color: getTypeColor(update?.type) }} />
            </div>
            <div className="flex-1">
              <h4 className="font-semibold text-foreground mb-1">{update?.title}</h4>
              <p className="text-sm text-muted-foreground mb-2">{update?.description}</p>
              <p className="text-xs text-muted-foreground">{update?.date}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PolicyUpdates;